import { IRemoteModuleManifest } from '../types';

export const getContainerName = (manifest: IRemoteModuleManifest, key: string) =>
  manifest?.alias || key;
